import { render, staticRenderFns } from "./TagsList.ts.vue?vue&type=template&id=d86b4852&scoped=true"
import script from "./TagsList.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagsList.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TagsList.ts.vue?vue&type=style&index=0&id=d86b4852&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86b4852",
  null
  
)

export default component.exports